"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthlySavingsCms = void 0;
var MonthlySavingsCms = /** @class */ (function () {
    function MonthlySavingsCms() {
        this.hoorayLabel = "Hooray! ";
        this.savingLabel = "You\u2019ll save a total of {0}/mo. on your current lines. ";
        this.seeYourSavingLinkLabel = "See your savings";
        this.monthlyPricesLabel = "Your monthly plan price per line will go down with today's order.\n     That's a total savings of {0} each month on your current lines!";
    }
    return MonthlySavingsCms;
}());
exports.MonthlySavingsCms = MonthlySavingsCms;
//# sourceMappingURL=MonthlySavings.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/MonthlySavings/MonthlySavings.cms.js
// module id = 2259
// module chunks = 8